// extracted by mini-css-extract-plugin
module.exports = {"page-container":"page-container-5a928c3e9fd7743a65bf52571a5ee765"};